import { HOTEL_CEM_STAR_TYPE_ENUM } from '@/hotelcem/constants/index'

export const getHotelCEMStarTypeEnum = key => {
  if (!HOTEL_CEM_STAR_TYPE_ENUM[key]?.label) {
    return ''
  }
  return HOTEL_CEM_STAR_TYPE_ENUM[key]?.label
}
